export default __webpack_public_path__ + "static/893-516dc65f6898b6828c42ccb956d8e626.gif";